import { useSession } from "@pontimed/auth-client";
import { Navigate, createFileRoute } from "@tanstack/react-router";

import { Skeleton } from "@/components/ui/skeleton";

import { hasAdminAccess } from "@/lib/permissions";

/**
 * Root index — auth-aware redirect:
 *   loading                → skeleton
 *   authenticated + admin  → /dashboard
 *   authenticated + other  → /login (the _authenticated gate handles 403 too,
 *                                    but landing on /login keeps non-admins out
 *                                    of the admin shell entirely)
 *   guest                  → /login
 */
export const Route = createFileRoute("/")({
  component: IndexRoute,
});

function IndexRoute() {
  const { status, user } = useSession();

  if (status === "loading") {
    return (
      <div className="flex min-h-dvh items-center justify-center">
        <Skeleton className="h-12 w-48" />
      </div>
    );
  }

  if (status === "authenticated" && hasAdminAccess(user)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Navigate to="/login" replace />;
}
